import React, {useContext, useState} from 'react'
import { useFormik } from 'formik';
import { StaticImage } from 'gatsby-plugin-image';
import useFormSubmit from '~/hooks/useFormSubmit';
import * as Yup from 'yup';
import TransContext from '~/contexts/TransContext';

export default function SidebarNewsletterSubscribe() {
  const trans = useContext(TransContext);
  const [isSubmitted, setIsSubmitted] = useState(false);

  // eslint-disable-next-line
  const { post, loading, response } = useFormSubmit({
    url: '/.netlify/functions/autopilot-form',
    setIsSubmitted
  });

  const formik = useFormik({
    initialValues: {
      contact: {
        Email:''
      }
    },
    validationSchema: Yup.object({
      contact: Yup.object({
        Email: Yup.string().email('Invalid email address').required('Required')
      })
    }),
    onSubmit: async (values) => {
      values.contact.unsubscribed = false;
      values.contact._autopilot_list = '44087410-EF96-4FF8-9233-3F58E1C48AD6';
      await post(values);
    },
  });

  return (
    <div>
      {!isSubmitted ? (
        <>
          <div className="">
            <StaticImage src={`../assets/images/shared/polaroid-plate.png`} height={60} alt="" />
          </div>
          <div className={`max-w-sm `}>
            <h3 className="mt-7 text-black text-28px tracking-2 font-bold leading-[1.11em] font-heading">
              {trans?.content?.sidebarNewsletterHeading}
            </h3>
            <div className="mt-3 font-normal leading-snug tracking-tighter text-14px ">
              <p>{trans?.content?.sidebarNewsletterContent}</p>
            </div>
          </div>
          <div className="mt-8">
            <form
              noValidate
              onSubmit={formik.handleSubmit}
              className={`
              ${loading && 'pointer-events-none'}
            `}
            >
              <input
                type="email"
                name="contact.Email"
                className={`block w-full font-bold uppercase bg-transparent border border-black outline-none h-11 text-10px leading-[1.4em] pl-4
            ${formik.touched?.contact?.Email && formik.errors?.contact?.Email && 'border-[#ff0000] text-[#ff0000]'}`}
                placeholder={trans?.content?.enterYourEmail}
                onChange={formik.handleChange}
                value={formik.values.contact?.Email}
              />

              <div className="mt-1">
                <button
                  type="submit"
                  className="flex flex-col justify-center w-full transition-opacity duration-100 bg-blue hover:opacity-80"
                >
                  <div className="mx-auto font-bold leading-tight pointer-events-none c-btn c-btn--no-icon c-btn--primary hover:bg-blue h-11 text-14px tracking-2">
                    {trans?.content?.subscribe}
                  </div>
                </button>
              </div>
            </form>
          </div>
        </>
      ) : (
        <>
          <StaticImage src={`../assets/images/shared/polaroid-plate.png`} height={60} alt="" />
          <h4
            className="text-h4 tracking-2 font-bold font-heading mt-3"
            dangerouslySetInnerHTML={{ __html: trans?.content?.newsletterConfirmationHeading }}
          />
        </>
      )}
    </div>
  );
}
